import React from 'react';
import PropTypes from 'prop-types';
import {
  WithStore,
} from 'pure-react-carousel';

import './carousel-indicator.less';

/**
 * Indicator is a horizontal bar that indicates where a user is in a Carousel.
 * It is intended to be used inside of a <CarouselProvider /> component from
 * pure-react-carousel.
 *
 * https://github.com/express-labs/pure-react-carousel#withstore-higher-order-component
 */
export class Indicator extends React.PureComponent {
  render() {
    const {
      totalSlides,
      currentSlide,
    } = this.props;

    // Width of indicator is a percentage
    const indicatorWidth = 100 / totalSlides;
    // Left position of indicator is width * currentSlide (indexed at 0)
    const indicatorLeft = indicatorWidth * currentSlide;
    return (
      <div className='carouselIndicator'>
        <div className='indicatorTotal'>
          <div
            className='indicator'
            style={{
              width: `${indicatorWidth}%`,
              left: `${indicatorLeft}%`,
            }} />
        </div>
      </div>
    );
  }
}

Indicator.propTypes = {
  totalSlides: PropTypes.number.isRequired,
  currentSlide: PropTypes.number.isRequired,
};

const CarouselIndicator = WithStore(Indicator, (state) => ({
  currentSlide: state.currentSlide,
  totalSlides: state.totalSlides,
}));

export default CarouselIndicator;
